import { Page } from '../../components/page-view/types';
import ebdcoms from '../ebdcoms';

export * from './flow';
export * from './mobile';
export * from './pc';
export * from './types';

// eslint-disable-next-line max-len
export function loadThemeStyle(appCss = '', pageCss = '', page: Page) {
  ebdcoms.asyncExcu('importStyles')(
    {
      styleId: 'ebd_appthemecode_style',
      styleKey: `app_${page?.appid || 'appid'}`,
    },
    appCss,
  );
  ebdcoms.asyncExcu('importStyles')(
    {
      styleId: 'ebd_pagethemecode_style',
      styleKey: `page_${page?.id || 'pageId'}`,
    },
    pageCss,
  );
}

export default {};
